// @flow
import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { MessageInputBox, TextBlock } from 'bench-internal-theme';

import MessageCard from './MessageCard';
import type { ClientComment, InternalNote } from './types';

const MessageListLayout = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-row-gap: 16px;
`;

type MessageListProps = {
  createMessage?: (body: string) => Promise<any>,
  deleteMessage?: (messageId: string) => any,
  editMessage?: (messageId: string, body: string) => any,
  flagMessage?: (messageId: string, flagged: boolean) => any,
  messages: Array<InternalNote | ClientComment>,
  placeholder?: string,
  zeroStateMessage?: string,
};

const MessageList = ({
  createMessage,
  deleteMessage,
  editMessage,
  flagMessage,
  messages,
  placeholder,
  zeroStateMessage,
}: MessageListProps) => (
  <MessageListLayout>
    {messages.length > 0 ? (
      <div>
        {messages.map(message => (
          <MessageCard
            key={message.id}
            deleteMessage={deleteMessage && (() => deleteMessage(message.id))}
            editMessage={editMessage && (body => editMessage(message.id, body))}
            flagMessage={flagMessage && (flagged => flagMessage(message.id, flagged))}
            message={message}
          />
        ))}
      </div>
    ) : (
      <TextBlock color={colors.dust} styleType="small">
        {zeroStateMessage}
      </TextBlock>
    )}
    {createMessage && (
      // The key prop causes this MessageInputBox to be replaced whenever a new message is
      // successfully posted.
      // FIXME This loses the user's in progress message when an existing message is deleted
      <MessageInputBox
        key={messages.map(({ id }) => id).join()}
        placeholder={placeholder}
        onPost={body => createMessage(body)}
      />
    )}
  </MessageListLayout>
);

MessageList.defaultProps = {
  createMessage: undefined,
  deleteMessage: undefined,
  editMessage: undefined,
  flagMessage: undefined,
  placeholder: undefined,
  zeroStateMessage: undefined,
};

export default MessageList;
